const scUtil= {
	globalData: {
		 //apiServer: 'http://localhost:24471/',//develop11
		 //apiServer: 'http://api.luoke.test.0513soft.com/', //develop1
		 apiServer: 'https://api.chinaroke.com/',//produce
	},
	axiosPost(obj, url, data, callback) {

		let fullServer = this.globalData.apiServer + url;
		//alert(fullServer);
		let loginToken = localStorage.getItem('logintoken');
		let locale = localStorage.getItem('locale-lang') || 'zh-CN';
		obj.axios.post(fullServer, data, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"Authorization": loginToken,
				"Accept-Language": locale
			}
		}).then(res => {
			callback(res.data);
		}).catch(error => {
			if (error.status == 401) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				//obj.$message.error('登录失效');
				//obj.$router.replace({
					//name: 'LoginVue'
				//});
				//修改：不再跳转，通过回调返回错误信息
				callback({code:401,message:'登录失效'})
			} else if (error.status == undefined) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				//obj.$message.error('获取数据失败');
				//obj.$router.replace({
					//name: 'LoginVue'
				//});
				callback({ code: -1, message: '获取数据失败' });
			} else {
				// 其他错误也通过回调返回
				callback({ code: error.status, message: '请求失败' });
			}
		});
	},
	axiosPut(obj, url, data, callback) {
		let fullServer = this.globalData.apiServer + url;
		//alert(fullServer);
		let loginToken = localStorage.getItem('logintoken');
		//console.log(loginToken);
		let locale = localStorage.getItem('locale-lang') || 'zh-CN';
		obj.axios.post(fullServer, data, {
			headers: {
				"Content-Type": "application/json",
				"Authorization": loginToken,
				"Accept-Language": locale
			}
		}).then(res => {
			callback(res.data);
		}).catch(error => {
			//401表示需要鉴权
			if (error.status == 401) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				//obj.$message.error('登录失效');
				//obj.$router.replace({
					//name: 'LoginVue'
				//});
				// 修改：不再跳转，通过回调返回错误信息
				callback({ code: 401, message: '登录失效' });
			} else if (error.status == undefined) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				//obj.$message.error('获取数据失败');
				//obj.$router.replace({
					//name: 'LoginVue'
				//});
				// 修改：不再跳转，通过回调返回错误信息
				callback({ code: -1, message: '获取数据失败' });
			} else {
				callback({ code: error.status, message: '请求失败' });
			}
		});
	},
	axiosUpload(obj, url, data, callback) {
		let fullServer = this.globalData.apiServer + url;
		//alert(fullServer);
		let loginToken = localStorage.getItem('logintoken');
		//console.log(loginToken);
		obj.axios.post(fullServer, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
				"Authorization": loginToken
			}
		}).then(res => {
			callback(res.data);
		}).catch(error => {
			//401表示需要鉴权
			if (error.status == 401) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				//obj.$message.error('登录失效');
				//obj.$router.replace({
					//name: 'LoginVue'
				//});
				// 修改：不再跳转，通过回调返回错误信息
				callback({ code: 401, message: '登录失效' });
			} else if (error.status == undefined) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				//obj.$message.error('获取数据失败');
				//obj.$router.replace({
					//name: 'LoginVue'
				//});
				// 修改：不再跳转，通过回调返回错误信息
				callback({ code: -1, message: '获取数据失败' });
			} else {
				callback({ code: error.status, message: '请求失败' });
			}
		});
	},
	axiosGet(obj, url, data, callback) {
		let fullServer = this.globalData.apiServer + url;
		let loginToken = localStorage.getItem('logintoken');
		let locale = localStorage.getItem('locale-lang') || 'zh-CN';
		obj.axios.get(fullServer, data, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"Authorization": loginToken,
				"Accept-Language": locale
			}
		}).then(res => {
			callback(res.data);
		}).catch(error => {
			// 添加错误处理，保持一致性
			if (error.status == 401) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				// 修改：不再跳转，通过回调返回错误信息
				callback({ code: 401, message: '登录失效' });
			} else if (error.status == undefined) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				// 修改：不再跳转，通过回调返回错误信息
				callback({ code: -1, message: '获取数据失败' });
			} else {
				callback({ code: error.status, message: '请求失败' });
			}
		});
	},
	axiosPostImage(obj, url, data, callback) {
		obj.axios({
			url: this.globalData.apiServer + url + "?text=" + encodeURIComponent(data),
			method: 'post',
			responseType: 'blob', // 重要：设置响应类型为blob
		}).then(response => {
			callback(URL.createObjectURL(new Blob([response.data])));
		}).catch(error => {
			console.error('There was a problem fetching the image:', error);
			// 图片请求失败时也通过回调返回错误
			callback(null);
		});
	},
	dateFormatter(date, format) {
		if (!format) {
			format = 'Y-M-D h:m:s w';
		}

		var weekArray = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");

		const formatArr = ['Y', 'M', 'D', 'h', 'm', 's', 'w']
		const returnArr = []

		var year = date.getFullYear();
		let weekIndex = date.getDay();

		returnArr.push(year)
		returnArr.push(date.getMonth() + 1)
		returnArr.push(date.getDate())
		returnArr.push(date.getHours())
		returnArr.push(date.getMinutes())
		returnArr.push(date.getSeconds())
		returnArr.push(weekArray[weekIndex]);

		for (var i in returnArr) {
			format = format.replace(formatArr[i], this.formatNumber(returnArr[i]))
		}

		return format;
	},
	formatNumber(n) {
		n = n.toString()
		return n[1] ? n : '0' + n
	},
	getGuid() {
		return "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/[x]/g, () =>
			Math.floor(Math.random() * 16)
			.toString(16)
			.toUpperCase()
		);
	},
	checkLogin(obj, callback) {
		const data = {
			userName: localStorage.getItem('username')
		};
		let fullServer = this.globalData.apiServer + 'loginApi/CheckLogin';
		//alert(fullServer);
		let loginToken = localStorage.getItem('logintoken');
		//console.log(loginToken);
		if (loginToken == undefined || loginToken == '') {
			callback(false);
			return;
		}
		obj.axios.post(fullServer, data, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"Authorization": loginToken
			}
		}).then(res => {
			callback(true);
		}).catch(error => {
			if (error.status == 401) {
				callback(false);
			} else if (error.status == undefined) {
				localStorage.setItem('username', "");
				localStorage.setItem('logintoken', "");
				// obj.$message.error('获取数据失败');
				// obj.$router.replace({
				// 	name: 'LoginVue'
				// });
				// 修改：不再跳转，通过回调返回错误信息
				callback(false);
			} else {
				callback(false);
			}
		});
	}
};

export default scUtil;